import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ButtonToolbar,
  Button,
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import DateField from '../../../shared/components/form/DateField';

function PrintMenuModal(props) {
  const { t, toggle, modal, title, menuTitle, printDetailMenu, menuId } = props;
  const [selectedInitialDate, setSelectedInitialDate] = useState(new Date());
  const [selectedFinalDate, setSelectedFinalDate] =
    useState(selectedInitialDate);

  const onChangeInitialDate = (initialDate) => {
    setSelectedInitialDate(initialDate);
  };

  const onChangeFinalDate = (finalDate) => {
    setSelectedFinalDate(finalDate);
  };

  const updateDates = () => {
    printDetailMenu(selectedInitialDate, selectedFinalDate, menuId);
  };

  return (
    <Modal isOpen={modal} toggle={toggle} className="theme-light">
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        <form className="form" onSubmit={printDetailMenu}>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('screens.mnt_cardapio.printMenuParameters')} {menuTitle}
            </span>
          </div>
          <div className="form__form-group--2_columns">
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('general.initial_date')}
              </span>
              <div className="form__form-group-field">
                <Field
                  name="initialDate"
                  type="text"
                  component={DateField}
                  placeholder={t('general.initial_date')}
                  onChange={onChangeInitialDate}
                  selected={new Date()}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('general.final_date')}
              </span>
              <div className="form__form-group-field">
                <Field
                  name="finalDate"
                  type="text"
                  component={DateField}
                  placeholder={t('general.final_date')}
                  onChange={onChangeFinalDate}
                  minDate={selectedInitialDate}
                  selected={new Date()}
                />
              </div>
            </div>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="success" onClick={updateDates}>
            {t('general.generator')}
          </Button>
        </ButtonToolbar>
      </ModalFooter>
    </Modal>
  );
}

PrintMenuModal.propTypes = {
  t: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  modal: PropTypes.bool.isRequired,
  title: PropTypes.string,
  menuTitle: PropTypes.string.isRequired,
  printDetailMenu: PropTypes.func.isRequired,
  menuId: PropTypes.number.isRequired,
};

PrintMenuModal.defaultProps = {
  title: '',
};

export default reduxForm({
  form: 'PrintMenuModal',
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(PrintMenuModal));
